"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MapIconShadow = void 0;
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Shadow definition for map pin and cluster icon
 * @param props MapIconShadowProps
 * @returns JSX.IntrinsicElements.defs: React.SVGProps<SVGDefsElement>
 */
const MapIconShadow = props => {
  const {
    width,
    height,
    x,
    y
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("filter", {
      id: "shadow",
      x: x,
      y: y,
      width: width,
      height: height,
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feOffset", {
        dy: "1"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feGaussianBlur", {
        stdDeviation: "2.5"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.08 0"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feOffset", {
        dy: "2"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feGaussianBlur", {
        stdDeviation: "1"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.08 0"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow",
        result: "effect2_dropShadow"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow",
        result: "shape"
      })]
    })
  });
};
exports.MapIconShadow = MapIconShadow;
var _default = exports.default = MapIconShadow;
//# sourceMappingURL=MapIconShadow.js.map